<template>
  <NodeExhibition v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
import type { NodeExhibitionFragment } from '#graphql-operations'

defineOptions({
  name: 'ExhibitionDetail',
})

definePageMeta({
  name: 'exhibition-detail',
  languageMapping: {
    de: '/de/ausstellung/:slug(.*)*',
    fr: '/fr/exposition/:slug(.*)*',
    it: '/it/esposizione/:slug(.*)*',
    en: '/en/exhibition/:slug(.*)*',
  },
})

const nuxtRoute = useRoute()

const { data: query } = await useAsyncGraphqlQuery(
  'routeNodeExhibition',
  {
    path: nuxtRoute.path,
  },
  {
    transform: (v) => v.data,
    graphqlCaching: {
      client: true,
    },
  },
)

const { entity: node } = await useDrupalRoute<NodeExhibitionFragment>(
  query.value,
)

setLanguageLinksFromRoute(query.value)
await renderPageDependencies()
</script>
